import { render, staticRenderFns } from "./UserPortalOrders.vue?vue&type=template&id=6b081760&"
import script from "./UserPortalOrders.vue?vue&type=script&lang=js&"
export * from "./UserPortalOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports